import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ApplicationService } from '../../application/application.service';

export class Header {

  showHeaderBar = 0;
  showContact = false;
  stepProgress: number;

  // Unused variables
  showActivate = false;
  showProgressBar = false;
  progressPercent: number;

  constructor(showHeader: number, showProgress: boolean, progressPercent: number, contact: boolean, public step: string = '', activate: boolean = false) {
    this.showHeaderBar = showHeader;
    this.showContact = contact;

    // Unused variables
    this.showActivate = activate;
    this.showProgressBar = showProgress;
    this.progressPercent = progressPercent;
  }

}

@Injectable()
export class HeaderService {

  public ShowHeaderSource = new Subject<Header>();
  toggleHeader$: any = this.ShowHeaderSource.asObservable();

  constructor(private applicationService: ApplicationService) { }

  getStep(step) {
    return this.applicationService.getStepNo(step);
  }

}
